module.exports = __webpack_public_path__ + "img/BCGAME.adbc109a.svg";